let env;
let trackingHost;
let tokenHost;
let orderHost;
const context = '/innovel-services/scheduler-service/api';
const tokenContext = '/innovel-services/rft/api';
let loginClient;
let trackingHome;
let alertHost;
let alertContext = '/innovel-services/alert'

env = process.env.REACT_APP_RFT_ENV || 'local';

switch (env) {
  case 'local':
    trackingHost = 'http://localhost:8080';
    orderHost = 'http://localhost:8081';
    tokenHost = 'http://localhost:8085';
    loginClient = 'http://localhost:3005';
    trackingHome = 'http://localhost:3000';
    alertHost = 'http://localhost:8088';
    break;
  case 'prod':
    trackingHost = '';
    orderHost = '';
    tokenHost = '';
    loginClient = '';
    trackingHome = '/';
    alertHost = '';
    break;
  case 'nonprod':
    trackingHost = '';
    orderHost = '';
    tokenHost = '';
    loginClient = '';
    trackingHome = '/';
    alertHost = '';
      break;
  case 'qa':
    trackingHost = '';
    orderHost = '';
    tokenHost = '';
    loginClient = '';
    trackingHome = '/';
    alertHost = '';
      break;
  case 'perf':
    trackingHost = '';
    orderHost = '';
    tokenHost = '';
    loginClient = '';
    trackingHome = '/';
    alertHost = '';
      break;
  case 'dev':
    trackingHost = 'http://10.248.118.211:8080';
    orderHost = 'http://10.248.118.154:8083';
    tokenHost = 'http://10.248.118.207:8080';
    loginClient = 'http://10.248.118.50';
    trackingHome = 'http://10.248.118.55';
    alertHost = 'http://10.248.118.153:8080';
    break;
  default:
    trackingHost = '';
    orderHost = '';
    tokenHost = '';
    alertHost = '';
}

export const API_ROOT = orderHost + context;
export const API_SERVER = trackingHost + '/innovel-services';
export const TOKEN_ROOT = tokenHost + tokenContext;
export const APP_CONTEXT = '/innovel-services/scheduler-service';
export const LOGIN_ROOT = loginClient + '/innovel-services/login/login';
export const TRACKING_ROOT = trackingHome;
export const ALERT_ROOT = alertHost + alertContext;
